// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/LgpdTerms_SaveResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /lgpd_terms/save
 *
 * Returns the ID of the created or updated LGPD term.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface LgpdTerms_SaveResponseDados {
id: number
}

export type LgpdTerms_SaveResponse = ApiResponse<LgpdTerms_SaveResponseDados>;

registerResponseContract('LgpdTerms_SaveResponse', {
  id: { type: 'number',  required: true },
})
